// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"e09cc7c2","455":"0f5e36d1","977":"49345d94"}[chunkId] + ".chunk.js";
};